import { render } from "./DeviceDetails.vue?vue&type=template&id=a2272344"
import script from "./DeviceDetails.vue?vue&type=script&lang=js"
export * from "./DeviceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__